// /frontend/src/pages/tecnicaloffice/contracts/ToContractsEdit.tsx

import React from 'react';
import { Card, Spin, Alert } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ToContracts } from '../../../types';
import { fetchSqlData } from '../../../services/api';
import ToContractsCreate from './ToContractsCreate';

const ToContractsEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const contractId = Number(id);

  const { data, isLoading, error } = useQuery<ToContracts[], Error>({
    queryKey: ['toContract', contractId],
    queryFn: async () => {
      const results = await fetchSqlData('to_contracts', 'id', contractId);
      const rows = Array.isArray(results)
        ? results
        : (results?.data || results?.rows || []);
      return rows as ToContracts[];
    },
    enabled: Number.isFinite(contractId) && !!contractId,
  });

  const record = data && data.length > 0 ? data[0] : null;

  if (isLoading) return <Spin />;
  if (error) return <Alert type="error" message={error.message} />;
  if (!record) return <Alert type="warning" message="Record not found" />;

  return (
    <Card style={{ margin: 16 }}>
      <ToContractsCreate
        mode="edit"
        initialValues={record}
        onCancel={() => navigate('/to/contracts')}
      />
    </Card>
  );
};

export default ToContractsEdit;